<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">This book would not be possible without the assistance of many people. Special thanks go out to Jim Ignasher; Rich and Ally Alarie; Seth Pincins; PTL Paranormal; the LaFleur family in Whitinsville; Deb Vickers of DLH Paranormal; Kathy Hartley and the Friends of the Hearthside in Lincoln, Rhode Island; Carl Johnson; Kelly Pincins; Lori and Marty of Slater Mill in Pawtucket; everyone at Waterfront Mary’s; Keith and Sandra Johnson; Ken DeCosta; the Paranormal Bikers; Skip Gervais; the Greenville Public Library; Jeanne and Vance at Granville’s Pub; Deb, Chris and everyone at the Tavern on Main in Chepachet; Kent Spottswood; Burrillville Historical Society; Emma Nadeau; the Jessie Smith Library in Burrillville; Brown and Hopkins Country Store; Stone Mill Antiques; Glocester Heritage Society; Blackstone Valley Historical Society; Cumberland Library; Tom Sanzi; the Uxbridge Free Library; Worcester Historical Museum; the Worcester Art Museum; and everyone else who was of invaluable assistance but chose to remain anonymous. Thanks everyone, and many happy haunts!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?40fa476e